import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';
import SponsorsPartners from 'components/NextconLabSponsorsPartners/SponsorsPartners';

function FsponsorsPartners() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <SponsorsPartners/>
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <SponsorsPartners/>
        <Footer />
      </>
    )}
    </>
  );
}

export default FsponsorsPartners;
